import {
  Button,
  ButtonTypes,
  TextInput,
  FormError,
} from 'fitbeat.react-native-components';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { KeyboardAvoidingView, Platform, SafeAreaView, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { IAppStore } from '../HomeWorkouts/reducer';
import Theme from '../theme';
import { defaultScale, scaleText } from '../utils/scaling';
import UserDataConsumer from '../utils/UserDataConsumer';
import {
  isEmailValid,
  isRequired,
} from '../utils/validator';
import { inviteFamilyMember } from './actions';
import { inviteFamilyPlanMemberErrorSelector, InviteMemberButtonLoadingSelector } from './selector';

interface IProps {
  t: any;
  handleSubmit: any;
  inviteFamilyMember: () => void;
  isLoading: boolean;
  inviteFamilyPlanMemberError: string;
}

class InviteMember extends Component<IProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { t, handleSubmit } = this.props;

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.contentContainer}>
          <Text style={styles.mainHeader}>{t('enterEmail')}</Text>
            <KeyboardAvoidingView
              keyboardVerticalOffset={120}
              behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
              style={{justifyContent: 'space-between', flex: 1}}
            >
              <View style={styles.inputContainer}>
                <Field
                 isRequired={true}
                 forwardRef
                 editable={true}
                 name='email'
                 component={TextInput}
                 autoCapitalize='none'
                 keyboardType='email-address'
                 validate={[isRequired, isEmailValid]}
                 inputContainerStyle={styles.inputContainerStyle}
                 placeholder={t('emailForm')}
                />
                <FormError error={this.props.inviteFamilyPlanMemberError} color={Theme.GREY_DARK} />
              </View>
              <View style={styles.sendInviteContainer}>
                <Button
                  title={t('sendInvite')}
                  onPress={handleSubmit(this.props.inviteFamilyMember)}
                  buttonType={ButtonTypes.NORMAL}
                  contentContainerStyle={styles.sendInvite}
                  overrideFontStyles={styles.sendInviteFontStyle}
                  isLoading={this.props.isLoading}
                />
              </View>
          </KeyboardAvoidingView>
        </View>
      </SafeAreaView>);
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: defaultScale(15)
  },
  mainHeader: {
    color: Theme.CHARCOAL,
    lineHeight: defaultScale(25),
    fontSize: defaultScale(24),
    fontFamily: Theme.Custom700,
    paddingTop: defaultScale(15),
  },
  inputContainer: {
    marginTop: defaultScale(20),
    backgroundColor: Theme.WHITE,
  },
  inputContainerStyle: {
    padding: defaultScale(5),
    backgroundColor: Theme.WHITE,
    borderWidth: 1,
    borderColor: Theme.GREY_MEDIUM_LIGHT,
  },
  sendInviteContainer: {
    marginBottom: defaultScale(20),
    marginTop: defaultScale(10),
  },
  sendInviteFontStyle: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
    color: Theme.WHITE,
  },
  sendInvite: {
    alignItems: 'center',
    borderColor: Theme.PRIMARY,
    borderRadius: defaultScale(5),
  },
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    isLoading: InviteMemberButtonLoadingSelector(state),
    inviteFamilyPlanMemberError: inviteFamilyPlanMemberErrorSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  const userServiceClient = ownProps.user.userServiceClient;
  const navigation = ownProps.navigation;
  const userProfile = ownProps.user.userProfile;

  return {
    inviteFamilyMember: (values) =>
    dispatch(inviteFamilyMember(navigation, userServiceClient, values.email, userProfile)),
  };
};

const inviteMemberState = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(InviteMember));
const inviteMemberReduxForm = reduxForm({ form: 'InviteMemberForm' })(inviteMemberState);
export default translate(['familyPlan'], { wait: true })(inviteMemberReduxForm);
